import React, { useEffect, useState } from 'react';
import img from './../assets/Logo_MVSU.png';
import img1 from './../assets/imageLogo1.png';

import 'bootstrap/dist/css/bootstrap.min.css';
import "../css/header.css";
import LanguageDropdown from './LanguageDropdown';

const Header = () => {
  const [currentDateTime, setCurrentDateTime] = useState('');
  const [isEnglish, setIsEnglish] = useState(false);

  useEffect(() => {
    const currentPath = window.location.pathname;
    setIsEnglish(currentPath.includes('/en/'));
  }, []);

  useEffect(() => {
    const updateTime = () => {
      const now = new Date();
      const hour = now.getHours();

      let greeting = '';
      if (hour >= 5 && hour < 12) {
        greeting = isEnglish ? 'Good Morning' : 'शुभ प्रभात';
      } else if (hour >= 12 && hour < 17) {
        greeting = isEnglish ? 'Good Afternoon' : 'शुभ अपराह्न';
      } else if (hour >= 17 && hour < 20) {
        greeting = isEnglish ? 'Good Evening' : 'शुभ संध्या';
      } else {
        greeting = isEnglish ? 'Good Night' : 'शुभ रात्रि';
      }

      const dateStr = now.toLocaleDateString(isEnglish ? 'en-IN' : 'hi-IN', {
        weekday: 'long',
        year: 'numeric',
        month: 'long',
        day: 'numeric',
        timeZone: 'Asia/Kolkata'
      });

      const timeStr = now.toLocaleTimeString(isEnglish ? 'en-IN' : 'hi-IN', {
        hour: '2-digit',
        minute: '2-digit',
        second: '2-digit',
        hour12: true,
        timeZone: 'Asia/Kolkata'
      });

      setCurrentDateTime(`${greeting}, ${dateStr}, ${timeStr}`);
    };

    updateTime();
    const intervalId = setInterval(updateTime, 1000);
    return () => clearInterval(intervalId);
  }, [isEnglish]);

  return (
    <>

      <div
        className="top-bar"
        style={{
          backgroundColor: 'rgb(213 213 213)',
          height: '35px',
          display: 'flex',
          alignItems: 'center',
          padding: '0 20px',
          fontSize: '13px',
          color: '#444',
          justifyContent: 'space-between',
          flexWrap: 'wrap',
          gap: '10px'
        }}
      >
        <div style={{ flex: '1', minWidth: '150px', color: 'lightblack', fontWeight: '600', textAlign: 'left', }}>
          <strong>{currentDateTime}</strong>
        </div>

        <div style={{ flex: '0 1 auto' }}>
          <LanguageDropdown />
        </div>

        <div style={{ display: 'flex', alignItems: 'center', gap: '16px' }}>
          <a
            href="https://wa.me/8708997181"
            target="_blank"
            rel="noopener noreferrer"
            aria-label="WhatsApp"
            className="social-icon"
          >
            <i className="fab fa-whatsapp" style={{ fontSize: '24px', color: '#25D366' }}></i>
          </a>

          <a
            href="https://www.youtube.com/@mvsuofficial"
            target="_blank"
            rel="noopener noreferrer"
            aria-label="YouTube"
            className="social-icon"
          >
            <i className="fab fa-youtube" style={{ fontSize: '24px', color: '#FF0000' }}></i>
          </a>

          <a
            href="https://www.facebook.com/mvsuofficial"
            target="_blank"
            rel="noopener noreferrer"
            aria-label="Facebook"
            className="social-icon"
          >
            <i className="fab fa-facebook-f" style={{ fontSize: '24px', color: '#3b5998' }}></i>
          </a>

          <a
            href="/login"
            aria-label="Login"
            style={{
              color: 'white',
              backgroundColor: 'black',
              padding: '6px 12px',
              borderRadius: '4px',
              textDecoration: 'none',
              fontWeight: '600',
              fontSize: '14px'
            }}
          >
            {isEnglish ? 'Login' : 'लॉग इन करें'}
          </a>
        </div>
      </div>


      <div
        style={{
          backgroundColor: 'white',
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
          flexWrap: 'wrap',
          padding: '0.5rem'
        }}
      >
        <img
          src={img}
          style={{ width: '12%', minWidth: '80px', marginLeft: "2%" }}
          alt="University Logo"
        />

        <div
          style={{
            textAlign: 'left',
            flex: '1',
            minWidth: '200px',
            paddingLeft: '1rem'
          }}
          className="header-text"
        >
          <h3
            className="university-name"
            style={{
              fontWeight: '900',
              color: '#77236b',
              marginBottom: '0.5rem'
            }}
          >
            महर्षि वाल्मीकि संस्कृत विश्वविद्यालय, मून्दड़ी, कैथल (हरियाणा)
          </h3>
          <h4
            className="fw-bold university-name"
            style={{
              marginBottom: '0.3rem',
              color: 'black'
            }}
          >
            Maharshi Valmiki Sanskrit University, Mundri, Kaithal (Haryana)
          </h4>
          <p
            className="affiliation"
            style={{
              fontSize: '0.8rem',
              marginBottom: '0.3rem',
              color: 'rgb(55, 100, 64)'
            }}
          >
            A State University established under Haryana Act No. 20/2018 & Recognized under UGC 2(F)
          </p>
          <p
            className="affiliation"
            style={{
              fontSize: '0.8rem',
              marginBottom: '0.3rem',
              color: 'rgb(136, 105, 68)'
            }}
          >
            हरियाणा सरकार के अधिनियम 20/2018 द्वारा संस्थापित राज्य विश्वविद्यालय एवं यूजीसी 2(f) के अन्तर्गत मान्यता प्राप्त
          </p>
        </div>

        <img
          src={img1}
          alt="Celebration Logo"
          style={{ width: '11%', minWidth: '60px', marginRight: "3%" }}
        />
      </div>


      <style>
        {`
          /* Top bar height for tablet and mobile */
          @media (max-width: 768px) {
            .top-bar {
              height: 55px !important;
            }
          }
          @media (max-width: 480px) {
            .top-bar {
              height: 65px !important;
            }
          }

          @media (max-width: 768px) {
            .university-name {
              font-size: 1.5rem !important; 
            }
            .university-location {
              font-size: 1.2rem !important;
            }
            .affiliation {
              font-size: 0.9rem !important;
            }
          }

          @media (max-width: 480px) {
            .university-name {
              font-size: 1.2rem !important;
            }
            .university-location {
              font-size: 1rem !important;
            }
            .affiliation {
              font-size: 0.8rem !important;
            }
          }
        `}
      </style>
    </>
  );
};

export default Header;
